import { api } from '@/api'

const actions = {
  fetchCountries: async ({ rootState, commit }) => {
    try {
      const {
        data: { data: countries },
      } = await api.get('/api/v1/step/cart/countries', {
        params: { cart: rootState.Cart.hash },
      })
      commit('SET_COUNTRIES', countries)
      return countries
    } catch (error) {
      throw Error(error)
    }
  },
  changeCountry: async ({ rootState, commit }, countryId) => {
    try {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', true, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', true, { root: true })
      const {
        data: { data },
      } = await api.post('/api/v1/step/cart/countries', {
        cart: rootState.Cart.hash,
        country_id: countryId,
      })

      commit('Cart/SET_CART', { ...data, selected_installment: null }, { root: true })
      commit('Checkout/SET_CART', { ...data }, { root: true })
    } catch (error) {
      throw Error(error)
    } finally {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', false, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', false, { root: true })
    }
  },
}

export default actions
